class GWPrice extends HTMLElement {
  SECTION_ID = 'ca-price';

  constructor() {
    super();
    this.productHandle = this.getAttribute('product-handle');
    this.productVariant = this.getAttribute('product-variant');

    this.activeCurrency = Shopify.currency.active;
    this.sessionKey = 'priceDetails-' + this.activeCurrency + '-' + this.productHandle;
  }

  async connectedCallback() {
    const priceDetails = await this.getPriceDetails();
    this.render(priceDetails);
  }

  /**
   * Render the price and compare at price
   * @param {Object} priceDetails
   * @param {String} priceDetails.price
   * @param {String} priceDetails.compareAtPrice
   */
  render(priceDetails) {
    const price = priceDetails?.price;
    const compareAtPrice = priceDetails?.compareAtPrice;

    const priceElement = document.createElement('span');
    priceElement.innerHTML = price;
    if (price && compareAtPrice) priceElement.classList.add('gw-product-card__price--sale');

    const compareAtPriceElement = document.createElement('span');
    compareAtPriceElement.classList.add('gw-product-card__price-compare');
    compareAtPriceElement.innerHTML = compareAtPrice;

    this.appendChild(compareAtPriceElement);
    this.appendChild(priceElement);
  }

  /**
   * Fetch the price from the shopify section rendering api
   * @param {String} productHandle
   * @returns {Object} priceDetails
   * @returns {String} price
   * @returns {String} compareAtPrice
   */
  async fetchPriceDetails(productHandle, productVariant) {
    try {
      if (!productHandle) {
        throw new Error('Product handle is required');
      }

      const root = Shopify.routes?.root || '/';

      const params = new URLSearchParams();
      if (productVariant) params.append('variant', productVariant);
      params.append('sections', this.SECTION_ID);

      const response = await fetch(root + 'products/' + productHandle + '?' + params.toString());
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      const priceDetails = this.parsePrice(data);
      return priceDetails;
    } catch (error) {
      console.error('There has been a problem with your fetch operation:', error);
    }
  }

  async getPriceDetails() {
    // Check if the price details are saved in the session
    const priceDetailsFromSession = this.getPriceDetailsFromSession();
    if (priceDetailsFromSession) return priceDetailsFromSession;

    // Fetch the price details from the shopify
    const priceDetails = await this.fetchPriceDetails(this.productHandle, this.productVariant);

    this.savePriceDetailsToSession(priceDetails);
    return priceDetails;
  }

  savePriceDetailsToSession(priceDetails) {
    sessionStorage.setItem(this.sessionKey, JSON.stringify(priceDetails));
  }

  getPriceDetailsFromSession() {
    const priceDetails = sessionStorage.getItem(this.sessionKey);
    if (!priceDetails) {
      return null;
    } else {
      if (priceDetails === 'undefined') {
        sessionStorage.removeItem(this.sessionKey);
        return null;
      }

      return JSON.parse(priceDetails);
    }
  }

  /**
   * Parse the price from the response
   * @param {Object} response
   * @returns {Object}
   * @returns {String} price
   * @returns {String} compareAtPrice
   */
  parsePrice(response) {
    const html = new DOMParser().parseFromString(response[this.SECTION_ID], 'text/html');
    const jsonElement = html.querySelector('#price-json');
    const json = JSON.parse(jsonElement.textContent);
    return json;
  }
}

customElements.define('gw-price', GWPrice);
